import PropTypes from "prop-types";
import Button from "./Button";
import { Icon } from "@mui/material";

const ButtonDownload = (props) => {
  const { children, ...attribute } = props;
  return (
    <Button color="blue" {...attribute}>
      <Icon>download</Icon> {children}
    </Button>
  );
};

ButtonDownload.propTypes = {
  children: PropTypes.any,
};

ButtonDownload.defaultProps = {};

export default ButtonDownload;
